<template>
    <router-link
        :to="link.link"
        active-class="active"
        class="h-full w-20 flex flex-col items-center justify-center  transition-colors border-r border-transparent"
        :class="
            $route.name == link.link.name ||
            $route.path.split('/')[1].match(link.link.name.toLowerCase())
                ? 'bg-white  border-primary'
                : 'hover:bg-white hover:bg-opacity-20'
        "
    >
        <component
            v-bind:is="link.icon"
            :fillClass="
                $route.name == link.link.name ||
                $route.path.split('/')[1].match(link.link.name.toLowerCase())
                    ? 'fill-primary'
                    : 'fill-white'
            "
            class="w-7 h-5"
        />
        <div
            class="mt-1 text-xs transition-opacity"
            :class="
                $route.name == link.link.name ||
                $route.path.split('/')[1].match(link.link.name.toLowerCase())
                    ? 'text-primary'
                    : 'text-white'
            "
        >
            {{ link.name }}
        </div>
    </router-link>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        link: {
            type: Object,
            required: true,
        },
    },
});
</script>

<style></style>
